import React from 'react';
import clsx from 'clsx';
import { useRef } from 'react';

import { ModalMain } from '../main';
import { Button } from 'common/new-button';
import { useClickOutside } from 'hooks/useClickOutside';

import { Icon } from 'common/icon';

import styles from './styles.module.css';

interface Props {
  buttonId?: string;
  title: string;
  isVisible: boolean;
  headerTitle: string;
  onClose?: () => void;
  onSubmit?: () => void;
  confirmButtonTitle?: string;
}

export const ConfirmModal = ({
  buttonId,
  title,
  onClose,
  onSubmit,
  isVisible,
  headerTitle,
  confirmButtonTitle = 'Confirm',
}: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  useClickOutside({ onClick: onClose, ref: modalRef });

  return (
    <ModalMain
      title=""
      width={260}
      targetRef={modalRef}
      isVisible={isVisible}
      closeOnClick={onClose}
      footer={
        <div className={styles.button_wrapper}>
          <Button
            id={buttonId}
            onClick={onSubmit}
            text={confirmButtonTitle}
            className={clsx(styles.button, styles.confirm)}
          />
          <Button
            text="Cancel"
            onClick={onClose}
            className={clsx(styles.button, styles.cancel)}
          />
        </div>
      }
    >
      <div className={styles.body}>
        <div className={styles.header}>
          <span>{headerTitle}</span>
          <div className={styles.iconClose} onClick={onClose}>
            <Icon.Close />
          </div>
        </div>
        <span className={styles.body_text}>{title}</span>
      </div>
    </ModalMain>
  );
};
